import { DomainVO } from '../../vo/core/domain.vo';
import { VisionScenario, VisionCriteria, VisionWrapper, Vision } from '@wizeoo/akm-message-lib';
import { Model } from '../../model/model';
import { ExternalAPI } from '../../model/external-api';
import { VisionVO } from '@wizeoo/akm-compute-lib';
import { VISION_PROPERTY } from '../../model/enums';
import { WizCommand } from '@wizeoo/akm-component-lib';
import { WIZ_COMMAND_METHOD, WIZ_COMMAND_STATE } from '@wizeoo/akm-core-lib';
/** chargement complet d'une vision */
export class GetVisionCommand extends WizCommand<VisionWrapper> {
  
  protected model: Model = null;

  public vision: Vision;
  public visionCallback: Function= null;
  constructor(model: Model) {
    super();
    this.model = model;
  } 

  /**
   * chargement d'une vision
   */
  get(vision: Vision, callBack: Function = null): GetVisionCommand {
    
    this.vision = vision;
    
    const wrapper: VisionWrapper = new VisionWrapper();
    wrapper.scenario = new VisionScenario();
    wrapper.scenario.manageKeys = true;
    wrapper.scenario.manageSteps = true;
    wrapper.scenario.manageMeasures = true;
    // wrapper.criteria = new VisionCriteria();
    // wrapper.criteria.domain = this.model.domainCode;
    // wrapper.criteria.businessUnitCode = this.model.businessUnitCode;
    wrapper.method = WIZ_COMMAND_METHOD.GET;
    wrapper.entity = new Vision();
    wrapper.entity.domain = vision.domain;
    wrapper.entity.businessUnitCode = vision.businessUnitCode;
    wrapper.entity.code = vision.code;

    this.visionCallback = callBack;

    super.configureRemote(
      ExternalAPI.VISION_API,
      wrapper
    );

    return this;
  }

  wizResult() {
    super.wizResult();

    if (this.state === WIZ_COMMAND_STATE.SUCCESS) {
      
      if (this.result?.entity) {
        // console.log('vision loaded');
        const vo: VisionVO = this.model.visionEngine.newVisionVO(this.result.entity);
        this.model.syncService.checkLocal(null, vo);
        this.model.visionEngine.setVisionProperties(vo, VISION_PROPERTY.LOADED, true);
 
        this.model.visionEngine.feedVisions([vo], true);
        if(this.visionCallback) {
          this.visionCallback(this);
        }
      }
    }
  }

}
